import { render, staticRenderFns } from "./BaseVideo.vue?vue&type=template&id=fd39ca40&"
import script from "./BaseVideo.vue?vue&type=script&lang=js&"
export * from "./BaseVideo.vue?vue&type=script&lang=js&"
import style0 from "./BaseVideo.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SecondaryButton: require('/opt/build/repo/storefront/components/atoms/Button/SecondaryButton.vue').default})
